export const filters = [
	[

		{
			label: '内容',
			type: 'input',
			attr: 'content',
			placeholder: '请输入',
			column: 6,
		},
		{
			type: 'button',
			column: 4,
		},

	],
]

export const tableColumn = [
	{
		label: '序号',
		width: '120px',
		isCustomize: true,
		tableType: 'no',
	},
	{
		label: '内容',
		prop: 'content'
	},
	{
		label: '归属人',
		prop: 'username',
	},
	{
		label: '添加时间',
		prop: 'createTime'
	},
	{
		label: '操作',
		isCustomize: true,
		tableType: 'fastFlowOperate',
	}
]
